export function footer() {
  let openClass = 'open';
  function createOpenCloseButton() {
    const items = $(".footer-nav-list .menu-item-has-children");
    items.each((id, el) => {
      if($(el).find(".icon-plus").length <= 0) {
        $(el).find(".footer-nav-link").append(`<button type="button" aria-expanded="false" class="icon-plus"></button>`)
      }

    });
  }

  $('body').on('click', `.footer-nav-list .footer-nav-link`, function (e) {
      e.preventDefault();
    let $btn = $(this);
    let $item = $btn.closest('li');
    let isOpen = $item.hasClass(openClass);

    $btn
      .toggleClass(openClass)
      .attr('aria-expanded', !isOpen)
    $item
      .toggleClass(openClass)
      .find('.footer-nav-inner').slideToggle();
  });

  createOpenCloseButton();
}


// WEBPACK FOOTER //
// ./assets/js/modules/footer.js